import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Value {
    [prop: string]: any;
    IdDireccionDestino: number | undefined | null;
    IdSucursalDestino: number | undefined | null;
}

export interface Props {
    value: Value;
    onChange: (x: Value) => Promise<void> | void;
    /**En caso de que el usuario puede seleccionar solo los clientes de este cliente */
    idClienteUsuario?: number;
}

export class DestinoSucursal extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Value> {
        return {
            IdDireccionDestino: validation.required,
            IdSucursalDestino: validation.required
        };
    }

    onDireccionChange = async (idDireccion: number | null | undefined) => {
        if (idDireccion == null) {
            this.props.onChange({ ... this.props.value, IdSucursalDestino: undefined, IdDireccionDestino: idDireccion });
        } else {

            //Primero actualizamos el idDireccionDestino
            this.props.onChange({ ... this.props.value, IdDireccionDestino: idDireccion  });
            debugger;
            const sucursales = await resources.Sucursal.query({ IdDireccionCliente: idDireccion });
            const idSucursales = sucursales.map(x => x.IdRegistro);
            if (!contains(idSucursales, this.props.value.IdSucursalDestino)) {
                this.props.onChange({ ... this.props.value, IdSucursalDestino: first(idSucursales), IdDireccionDestino: idDireccion});
            } else {
                this.props.onChange({ ... this.props.value, IdDireccionDestino: idDireccion });
            }
        }
    }

    onSucursalChange = async (idSucursal: number) => {
        this.props.onChange({ ... this.props.value, IdSucursalDestino: idSucursal });
    }


    idClienteUsuario = (props: Props) => props.idClienteUsuario;
    filtroCliente = createSelectorRx(this.idClienteUsuario, idCliente => ({
    } as models.FiltroCliente));

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Direccion = getField(selectores.DireccionClienteSelector);
        const Sucursal = getField(selectores.Sucursal);
        const filtroCliente = this.filtroCliente(this.props);
        const Text = getField(kea.Text);
        return [
            <Direccion key={1} field="IdDireccionDestino" label="Destino" onChange={this.onDireccionChange} 
                                filtroCliente={filtroCliente} 
                                />,
            value.IdDireccionDestino != null && <Sucursal key={2} field="IdSucursalDestino" filtro={{ IdDireccionCliente: value.IdDireccionDestino }} onChange={this.onSucursalChange} label="Sucursal destino" />,
        ]; 
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/destinosucursal.tsx